import React from "react";
import { Input, Table } from "reactstrap";
import styles from "../InvoicesComponents.module.scss";

export default function DailyProfitSharingTable(props) {
  const {
    clientAmount,
    setClientAmount,
    totalAmount,
    setTotalAmount,
    cceAmount,
    setCceAmount,
    aeqonAmount,
    setAeqonAmount,
    facilityRebates,
    setFacilityRebates,
    onInputChange,
  } = props;

  function onChangeFacilityRebate(e, facilityId, name) {
    const tempDailyRebates = JSON.parse(JSON.stringify(facilityRebates));
    tempDailyRebates[facilityId][name] = Number(e.target.value);
    setFacilityRebates(tempDailyRebates);
  }

  return (
    <div>
      <Table bordered>
        <thead>
          <tr className={styles.CenterTable}>
            <th rowSpan={2}>Building</th>
            <th rowSpan={2}>Total</th>
            <th colSpan={2}>Client</th>
            <th colSpan={2}>CCE</th>
            <th colSpan={2}>Aeqon</th>
          </tr>
          <tr className={styles.CenterTable}>
            <th width="12.5%">Share</th>
            <th width="12.5%">Profit</th>
            <th width="12.5%">Share</th>
            <th width="12.5%">Profit</th>
            <th width="12.5%">Share</th>
            <th width="12.5%">Profit</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(facilityRebates).map((facility, index) => {
            return (
              <tr key={index} className={styles.CenterTable}>
                <th scope="row">{facility["nickname"]}</th>
                <td>
                  <Input
                    type="number"
                    value={Number(facility.total).toFixed(2)}
                    onChange={(e) =>
                      onChangeFacilityRebate(
                        e,
                        facility["facility_id"],
                        "total"
                      )
                    }
                    step={0.01}
                  />
                </td>
                <td>
                  {Number(facility.clientProfitSharePercentage).toFixed(2)}
                </td>
                <td>
                  <Input
                    type="number"
                    value={Number(facility.client).toFixed(2)}
                    onChange={(e) =>
                      onChangeFacilityRebate(
                        e,
                        facility["facility_id"],
                        "client"
                      )
                    }
                    step={0.01}
                  />
                </td>
                <td>{Number(facility.cceProfitSharePercentage).toFixed(2)}</td>
                <td>
                  <Input
                    type="number"
                    value={Number(facility.cce).toFixed(2)}
                    onChange={(e) =>
                      onChangeFacilityRebate(e, facility["facility_id"], "cce")
                    }
                    step={0.01}
                  />
                </td>
                <td>
                  {Number(facility.aeqonProfitSharePercentage).toFixed(2)}
                </td>
                <td>
                  <Input
                    type="number"
                    value={Number(facility.aeqon).toFixed(2)}
                    onChange={(e) =>
                      onChangeFacilityRebate(
                        e,
                        facility["facility_id"],
                        "aeqon"
                      )
                    }
                    step={0.01}
                  />
                </td>
              </tr>
            );
          })}
          <tr className={styles.CenterTable}>
            <th scope="row">Total</th>
            <td>
              <Input
                type="number"
                value={Number(totalAmount).toFixed(2)}
                onChange={(e) => onInputChange(e, setTotalAmount)}
                step={0.01}
              />
            </td>
            <td>-</td>
            <td>
              <Input
                type="number"
                value={Number(clientAmount).toFixed(2)}
                onChange={(e) => onInputChange(e, setClientAmount)}
                step={0.01}
              />
            </td>
            <td>-</td>
            <td>
              <Input
                type="number"
                value={Number(cceAmount).toFixed(2)}
                onChange={(e) => onInputChange(e, setCceAmount)}
                step={0.01}
              />
            </td>
            <td>-</td>
            <td>
              <Input
                type="number"
                value={Number(aeqonAmount).toFixed(2)}
                onChange={(e) => onInputChange(e, setAeqonAmount)}
                step={0.01}
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
